import { Link } from "react-router-dom";
import { motion } from "motion/react";

const consultTypes = [
  {
    icon: "ri-user-voice-line",
    title: "1:1 상담",
    description:
      "경매 입문부터 고급 전략까지, 궁금한 점을 전문가와 1:1로 상담하세요.",
    href: "/consultation?type=general",
  },
  {
    icon: "ri-file-search-line",
    title: "물건분석 상담",
    description:
      "관심 있는 경매 물건의 권리분석과 투자 가치를 전문가가 직접 검토해드립니다.",
    href: "/consultation?type=analysis",
  },
  {
    icon: "ri-store-line",
    title: "매매사업자 상담",
    description:
      "매매사업자를 위한 세무, 자금조달, 물건 선정까지 비즈니스 전반을 상담합니다.",
    href: "/consultation?type=business",
  },
];

const sectionVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.2,
    },
  },
};

const fadeUpVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] as const },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.1, 0.25, 1] as const,
      delay: 0.2 + i * 0.15,
    },
  }),
};

export default function ConsultationCTA() {
  return (
    <section className="relative w-full py-16 md:py-20 px-4 md:px-6 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img loading="lazy" decoding="async"
          src="https://img.echotwin.kr/kangstudy/a6bece6ce6dd3b6d.jpg"
          alt="1:1 상담 신청"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#1C1917]/85"></div>
      </div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        variants={sectionVariants}
        className="relative z-10 max-w-[1280px] mx-auto"
      >
        {/* Section Header */}
        <motion.div variants={fadeUpVariants} className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-white/10 text-white/90 rounded-full mb-3">
            맞춤 상담 서비스
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
            1:1 상담 신청
          </h2>
          <p className="text-sm text-white/70 max-w-[500px] mx-auto">
            혼자 고민하지 마세요. 경매 전문가가
            <br />
            투자 여정의 든든한 파트너가 되어드립니다
          </p>
        </motion.div>

        {/* Consultation Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
          {consultTypes.map((item, idx) => (
            <motion.div
              key={idx}
              custom={idx}
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-50px" }}
              whileHover={{ y: -6, backgroundColor: "rgba(255,255,255,0.15)" }}
              transition={{ type: "spring", stiffness: 300, damping: 15 }}
              className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-xl p-6 md:p-8 transition-colors cursor-pointer"
            >
              <div className="w-11 h-11 rounded-xl bg-[#C4956A]/30 flex items-center justify-center mb-5">
                <i className={`${item.icon} text-lg text-[#C4956A]`}></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-3">{item.title}</h3>
              <p className="text-sm text-white/70 leading-relaxed mb-5">
                {item.description}
              </p>
              <Link
                to={item.href}
                className="inline-flex items-center gap-2 text-sm font-medium text-[#C4956A] hover:text-white transition-colors"
              >
                상담 신청하기
                <i className="ri-arrow-right-line"></i>
              </Link>
            </motion.div>
          ))}
        </div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 0.6, ease: "easeOut" as const }}
          className="text-center"
        >
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
            className="inline-block"
          >
            <Link
              to="/consultation"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-[#C4956A] text-white text-sm font-semibold rounded-full hover:bg-[#B08050] transition-all"
            >
              지금 바로 상담 신청하기
              <i className="ri-arrow-right-line"></i>
            </Link>
          </motion.div>
        </motion.div>
      </motion.div>
    </section>
  );
}